import { c as _c } from "react/compiler-runtime";
import type { MealPlan as MealPlanType } from '@data-access/graphql/schema.types';
import type { Icon } from '@phosphor-icons/react';
import { ChefHat, Coffee, ForkKnife } from '@phosphor-icons/react';
import { LineItem } from './line-item';
const MEAL_PLAN_LABELS: Record<string, string> = {
  allInclusive: 'All-Inclusive',
  bedAndBreakfast: 'Übernachtung mit Frühstück',
  breakfastIncluded: 'Frühstück inklusive',
  fullBoard: 'Frühstück, Mittagessen & Abendessen inklusive',
  halfBoard: 'Frühstück & Abendessen inklusive',
  halfBoardPlus: 'Halbpension Plus',
  noPlan: 'Selbstverpflegung'
};
const MEALPLAN_ICONS = new Map<MealPlanType, Icon>([['allInclusive', Coffee], ['breakfastIncluded', Coffee], ['fullBoard', Coffee], ['halfBoard', ForkKnife], ['noPlan', ChefHat]]);
type MealPlanProps = {
  mealPlan: MealPlanType;
};
export function MealPlan(t0) {
  const $ = _c(5);
  const {
    mealPlan
  } = t0;
  let t1;
  if ($[0] !== mealPlan) {
    t1 = MEALPLAN_ICONS.get(mealPlan) ?? ChefHat;
    $[0] = mealPlan;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const Icon = t1;
  const t2 = MEAL_PLAN_LABELS[mealPlan] ?? mealPlan;
  let t3;
  if ($[2] !== Icon || $[3] !== t2) {
    t3 = <LineItem icon={Icon}>{t2}</LineItem>;
    $[2] = Icon;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}